export default function Suggestions({ suggerimenti, onSelect, onClose }) {
  if (!suggerimenti.length) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "100%",
        marginTop: "6px",

        backgroundColor: "#ffffff",

        borderRadius: "14px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
        border: "1px solid rgba(0,0,0,0.15)",

        zIndex: 9999,
        overflow: "hidden",
        animation: "fadeIn 0.25s ease"
      }}
    >

      {/* 🔥 X PREMIUM PER CHIUDERE I SUGGERIMENTI */}
      <div
        onClick={onClose}
        style={{
          position: "absolute",
          top: "8px",
          right: "10px",
          fontSize: "18px",
          fontWeight: "bold",
          cursor: "pointer",
          color: "#444",
          padding: "4px 8px",
          borderRadius: "6px",
          transition: "all 0.25s ease"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "rgba(0,0,0,0.08)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "transparent";
        }}
      >
        ✕
      </div>

      {/* 🔥 LISTA SUGGERIMENTI */}
      <div style={{ paddingTop: "36px" }}>
        {suggerimenti.map((s, i) => (
          <div
            key={i}
            onClick={() => onSelect(s)}
            style={{
              padding: "12px 16px",
              cursor: "pointer",
              fontSize: "16px",
              color: "#222",
              transition: "all 0.25s ease",
              borderBottom:
                i !== suggerimenti.length - 1
                  ? "1px solid rgba(0,0,0,0.08)"
                  : "none"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(0,0,0,0.06)";
              e.currentTarget.style.paddingLeft = "20px";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.paddingLeft = "16px";
            }}
          >
            {s}
          </div>
        ))}
      </div>
    </div>
  );
}
